(function () {
  'use strict';

  var isMobile = window.innerWidth < 768;
  var N     = isMobile ? 26 : 48;
  var CDIST = isMobile ? 82 : 108;

  /* ── Canvas ─────────────────────────────────── */
  var cv = document.createElement('canvas');
  cv.style.cssText = 'position:fixed;inset:0;pointer-events:none;z-index:99999985;';
  document.body.appendChild(cv);
  var cx = cv.getContext('2d', { alpha: true });
  var W = 0, H = 0;

  function resize() { W = cv.width = window.innerWidth; H = cv.height = window.innerHeight; }
  resize();
  window.addEventListener('resize', resize, { passive: true });

  /* ── State ──────────────────────────────────── */
  var boost = 0;  /* 0-1: click energy, decays  */
  var tint  = 0;  /* 0-1: green bg overlay      */

  /* ── Ambient particles — PS4 XMB upward-bubble style ── */
  var pts = [];
  for (var i = 0; i < N; i++) {
    pts.push({
      x:  Math.random() * window.innerWidth,
      y:  Math.random() * window.innerHeight,
      vx: (Math.random() - 0.5) * 0.35,   // slight horizontal drift only
      vy: -(0.15 + Math.random() * 0.55),  // always upward
      r:  1.1 + Math.random() * 1.5,
      a:  0.07 + Math.random() * 0.17,
    });
  }

  /* ── Burst pool ─────────────────────────────── */
  var bursts = [];

  function spawnBurst(x, y) {
    var count = 9 + Math.round(boost * 8);   /* subtle: fewer particles */
    for (var i = 0; i < count; i++) {
      var ang   = Math.random() * 6.283;
      var speed = 0.8 + Math.random() * (2.8 + boost * 1.5);   /* slower = more fluid */
      bursts.push({
        x: x, y: y,
        vx: Math.cos(ang) * speed,
        vy: Math.sin(ang) * speed - 1.2,
        r: 1.6 + Math.random() * 2.8,        /* smaller dots */
        life: 1,
        decay: 0.007 + Math.random() * 0.009, /* longer-lived = more fluid */
      });
    }
  }

  /* ── Loop ───────────────────────────────────── */
  var last = performance.now();

  function tick(now) {
    var dt = Math.min((now - last) / 16.67, 2.2);
    last = now;

    boost = Math.max(0, boost - 0.025 * dt);
    tint  = Math.max(0, tint  - 0.030 * dt);

    cx.clearRect(0, 0, W, H);

    /* background green tint */
    if (tint > 0.003) {
      cx.fillStyle = 'rgba(0,185,95,' + (tint * 0.048) + ')';
      cx.fillRect(0, 0, W, H);
    }

    /* particle color: cool blue-white → warm green on boost */
    var cr = Math.round(110 - boost * 80);
    var cg = Math.round(190 + boost * 30);
    var cb = Math.round(255 - boost * 138);
    var speedMult = 1 + boost * 3.4;

    /* ambient update + draw — PS4 bubble: always up, reset at bottom */
    for (var i = 0; i < N; i++) {
      var p = pts[i];
      p.x += p.vx * speedMult * dt;
      p.y += p.vy * speedMult * dt;
      if (p.x < -4) p.x = W + 4;
      if (p.x > W + 4) p.x = -4;
      if (p.y < -8) {
        p.x  = Math.random() * W;
        p.y  = H + 8;
        p.vx = (Math.random() - 0.5) * 0.35;
        p.vy = -(0.15 + Math.random() * 0.55);
        p.r  = 1.1 + Math.random() * 1.5;
        p.a  = 0.07 + Math.random() * 0.17;
      }

      cx.beginPath();
      cx.arc(p.x, p.y, p.r, 0, 6.283);
      cx.fillStyle = 'rgba(' + cr + ',' + cg + ',' + cb + ',' + p.a + ')';
      cx.fill();
    }

    /* connection lines — liquid surface effect */
    var cDist  = CDIST + boost * 48;
    var cDist2 = cDist * cDist;
    for (var i = 0; i < N - 1; i++) {
      for (var j = i + 1; j < N; j++) {
        var dx = pts[i].x - pts[j].x;
        var dy = pts[i].y - pts[j].y;
        var d2 = dx * dx + dy * dy;
        if (d2 < cDist2) {
          var str = 1 - Math.sqrt(d2) / cDist;
          cx.globalAlpha = str * (0.06 + boost * 0.10);
          cx.strokeStyle = 'rgba(50,200,165,1)';
          cx.lineWidth   = 0.35 + str * 0.75;
          cx.beginPath();
          cx.moveTo(pts[i].x, pts[i].y);
          cx.lineTo(pts[j].x, pts[j].y);
          cx.stroke();
        }
      }
    }
    cx.globalAlpha = 1;

    /* burst particles */
    for (var i = bursts.length - 1; i >= 0; i--) {
      var b = bursts[i];
      b.vx *= 0.935;
      b.vy  = b.vy * 0.935 + 0.07 * dt;
      b.x  += b.vx * dt;
      b.y  += b.vy * dt;
      b.life -= b.decay * dt;
      if (b.life <= 0) { bursts.splice(i, 1); continue; }

      cx.beginPath();
      cx.arc(b.x, b.y, Math.max(0.1, b.r * b.life), 0, 6.283);
      cx.fillStyle = 'rgba(0,180,100,' + (b.life * 0.60) + ')';
      cx.fill();
    }

    requestAnimationFrame(tick);
  }

  requestAnimationFrame(function (t) { last = t; tick(t); });

  /* ── Page-Transition Trigger — only at tap point ── */
  window.addEventListener('fifteen-page-exit', function (e) {
    var x = (e.detail && e.detail.x != null) ? e.detail.x : W / 2;
    var y = (e.detail && e.detail.y != null) ? e.detail.y : H / 2;
    boost = Math.min(1, boost + 0.55);
    tint  = Math.min(1, tint  + 0.48);
    spawnBurst(x, y);
  });
})();
